// extracted by mini-css-extract-plugin
export default {"errorText":"AccountUpdateForm_errorText__Kxj5v","projectsList":"AccountUpdateForm_projectsList__yLsNz","localPermissions":"AccountUpdateForm_localPermissions__WQeev"};